import { Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EDIT_FAQ_SUCCESS_MESSAGES, editfaq } from 'src/app/core/constants/core.constant';
import { NUMBER } from 'src/app/core/enum/core.enum';
import { FaqServiceService } from 'src/app/core/services/faq-service/faq-service.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';

@Component({
  selector: 'app-edit-faq',
  templateUrl: './edit-faq.component.html',
  styleUrls: ['./edit-faq.component.scss']
})
export class EditFaqComponent implements OnInit {
  @ViewChild('unsavedChangesModalContent') unsavedChangesModalContent!: TemplateRef<any>;
  @ViewChild('submitModal') submitModal!: TemplateRef<any>;
  @Input() mode: boolean;
  @Input() selectedTab: string;
  @Output() modeChange = new EventEmitter<string>();
  @Output() toastMessage = new EventEmitter<{ type: string; message: string }>();
  @Output() unsavedChangesValue = new EventEmitter<any>();
  @ViewChild('navigateAwayModal') navigateAwayModal!: TemplateRef<any>;
  @ViewChild('WarningMsgModal', { static: false }) WarningMsgModal!: TemplateRef<any>;
  constants = editfaq;
  number = NUMBER;
  portalType: string;
  public modalService = inject(NgbModal);
  previousTab: string;
  isEditable: boolean;
  formGroups: { [key: string]: FormGroup[], } = {};
  sectionToDelete: { tab: string, index: number, faqId: number } | null = null;
  faqData;
  overview;
  account;
  your_project;
  request;
  users;
  contactUs;
  clientResources: any;
  your_projects;
  requests;
  projects;
  overviewCategoryId: any;
  accountCategoryId: any;
  projectsCategoryId: any;
  requestsCategoryId: any;
  usersCategoryId: any;
  contactCategoryId: any;
  clientresourceCategoryId: any;
  isEditFaq: boolean = true;
  hasUnsavedChanges: boolean = false;
  currentTab: string;
  prevtabArr: string[] = [];
  isUnsavedChangesOpened: boolean = false;
  deletedFaqIds: number[] = [];
  tabToDelete: string | null = null;
  indexToDelete: number | null = null;
  isInvalid: boolean;
  originalFaqData: any;
  permissionsData: any;
  isAddingNewFaq: boolean = false;
  errorMessage: string;
  isAddDeleteFaq: boolean = false;
  successMessages = EDIT_FAQ_SUCCESS_MESSAGES;
  isAddEditFaq: boolean;
  isEditDeleteFaq: boolean;
  isAddFaq: boolean;
  isDeleteFaq: boolean;
  static constants: { overview_faq: string; account_faq: string; projects_faq: string; requests_faq: string; users_faq: string; contactus_faq: string; client_resource_faq: string; };

  constructor(
    public FaqServiceService: FaqServiceService,
    public fb: FormBuilder,
    public loaderService: LoaderService,
  ) { }

  ngOnInit(): void {
    const userProfile = JSON.parse(localStorage.getItem('user-profile'));
    this.permissionsData = { ...userProfile.roleAssigned };
    this.initializeForms();
    this.isEditable = this.mode;
    this.selectTab(this.selectedTab);
    this.getFaqData();
    if (userProfile?.userTypeId == 1) {
      this.portalType = "customer";
    }
    else if (userProfile?.userTypeId == 2) {
      this.portalType = "studio";
    }
  }

  /**
   * initializeForms() - method to initialize the forms
   */
  public initializeForms(): void {
    this.formGroups[editfaq.overview_faq] = [];
    this.formGroups[editfaq.account_faq] = [];
    this.formGroups[editfaq.projects_faq] = [];
    this.formGroups[editfaq.requests_faq] = [];
    this.formGroups[editfaq.users_faq] = [];
    this.formGroups[editfaq.contactus_faq] = [];
    this.formGroups[editfaq.client_resource_faq] = [];
    this.setupFormListeners();
  }

  /**
 * getFaqData() - method to fetch the faq details
 */
  getFaqData(): void {
    this.loaderService.setLoadingState(true);
    this.FaqServiceService.getFaqdata().subscribe({
      next: (response: any) => {
        if (response) {
          this.faqData = response?.faqSearch;

          // Initialize categories
          const categories = {
            overview: null,
            account: null,
            projects: null,
            requests: null,
            users: null,
            contactUs: null,
            clientResources: null
          };

          // Populate categories based on faqCategoryId
          this.faqData.forEach(category => {
            switch (category.faqCategoryId) {
              case 1:
                categories.overview = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 2:
                categories.account = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 3:
                categories.projects = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 4:
                categories.requests = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 5:
                categories.users = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 6:
                categories.contactUs = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              case 7:
                categories.clientResources = {
                  ...category,
                  faq: _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`)
                };
                break;
              default:
                break;
            }
          });

          // Assign the categories to the component properties
          this.overview = categories.overview;
          this.account = categories.account;
          this.projects = categories.projects;
          this.requests = categories.requests;
          this.users = categories.users;
          this.contactUs = categories.contactUs;
          this.clientResources = categories.clientResources;

          // Populate the sections
          this.populateOverviewSections(this.overview?.faq);
          this.populateAccountsSection(this.account?.faq);
          this.populateProjectsSection(this.projects?.faq);
          this.populateRequestSection(this.requests?.faq);
          this.populateUsersSection(this.users?.faq);
          this.populateContactUsSection(this.contactUs?.faq);
          this.populateClientResourcesSection(this.clientResources?.faq);
          this.setupFormListeners();
          this.loaderService.setLoadingState(false);

          this.originalFaqData = {
            overview: JSON.parse(JSON.stringify(this.overview?.faq || [])),
            account: JSON.parse(JSON.stringify(this.account?.faq || [])),
            projects: JSON.parse(JSON.stringify(this.projects?.faq || [])),
            requests: JSON.parse(JSON.stringify(this.requests?.faq || [])),
            users: JSON.parse(JSON.stringify(this.users?.faq || [])),
            contactUs: JSON.parse(JSON.stringify(this.contactUs?.faq || [])),
            clientResources: JSON.parse(JSON.stringify(this.clientResources?.faq || [])),
          }
        } else {
          console.warn('FAQ data could not be retrieved.');
        }
      },
      error: (error) => {
        this.loaderService.setLoadingState(false);
        console.error('Error fetching FAQ details:', error);
      },
    });
  }

  /**
   * onMobileTabChange() - method to handle the tab change in mobile
   * @param event - the event object (probably the selected tab) 
   */
  onMobileTabChange(event: Event) {
    const newTab = (event.target as HTMLSelectElement).value;
    if (newTab === this.selectedTab) {
      return;
    }
    this.selectTab(newTab);
  }


  /**
 * setupFormListeners() - method to setup the form listeners to detect the changes in the faq's
 */
  // setupFormListeners(): void {
  //   Object.keys(this.formGroups).forEach(tab => {
  //     const formGroupArray = this.formGroups[tab];
  //     if (Array.isArray(formGroupArray)) {
  //       formGroupArray.forEach(formGroup => {
  //         if (formGroup instanceof FormGroup) {
  //           Object.keys(formGroup.controls).forEach(controlName => {
  //             formGroup.get(controlName).valueChanges.subscribe(() => {
  //               this.hasUnsavedChanges = true;
  //               this.unsavedChangesValue.emit(true);
  //             });
  //           });
  //         } else {
  //           console.error('Expected FormGroup but got:', formGroup);
  //         }
  //       });
  //     } else {
  //       console.error('Expected an array of FormGroup for tab:', tab);
  //     }
  //   });
  // }
setupFormListeners(): void {
  Object.keys(this.formGroups).forEach(tab => {
    this.processFormGroupArray(tab, this.formGroups[tab]);
  });
}
 
private processFormGroupArray(tab: string, formGroupArray: any): void {
  if (!Array.isArray(formGroupArray)) {
    console.error('Expected an array of FormGroup for tab:', tab);
    return;
  }
 
  formGroupArray.forEach(formGroup => this.processSingleFormGroup(formGroup));
}
 
private processSingleFormGroup(formGroup: any): void {
  if (!(formGroup instanceof FormGroup)) {
    console.error('Expected FormGroup but got:', formGroup);
    return;
  }
 
  this.subscribeToFormControls(formGroup);
}
 
private subscribeToFormControls(formGroup: FormGroup): void {
  Object.keys(formGroup.controls).forEach(controlName => {
    const control = formGroup.get(controlName);
 
    control?.valueChanges.subscribe(() => {
      this.hasUnsavedChanges = true;
      this.unsavedChangesValue.emit(true);
    });
  });
}
  /**
   * populateOverviewSections() - method to get the exisiting details to display in form
   * @param faqItems - the faq data
   */
  populateOverviewSections(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          title: [item.faqQuestions || '', Validators.required],
          details: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.overview_faq].push(section);
      });
    }
  }

  /**
  * populateAccountsSection() - method to get the exisiting details to display in form
  * @param faqItems - the faq data
  */
  populateAccountsSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          accountTitle: [item.faqQuestions || '', Validators.required],
          accountDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.account_faq].push(section);
      });
    }
  }

  /**
  * populateProjectsSection() - method to get the exisiting details to display in form
  * @param faqItems - the faq data
  */
  populateProjectsSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          projectTitle: [item.faqQuestions || '', Validators.required],
          projectDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.projects_faq].push(section);
      });
    }
  }

  /**
  * populateRequestSection() - method to get the exisiting details to display in form
  * @param faqItems - the faq data
  */
  populateRequestSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          requestTitle: [item.faqQuestions || '', Validators.required],
          requestDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.requests_faq].push(section);
      });
    }
  }

  /**
 * populateUsersSection() - method to get the exisiting details to display in form
 * @param faqItems - the faq data
 */
  populateUsersSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          userName: [item.faqQuestions || '', Validators.required],
          userDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.users_faq].push(section);
      });
    }
  }

  /**
 * populateContactUsSection() - method to get the exisiting details to display in form
 * @param faqItems - the faq data
 */
  populateContactUsSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          contactTitle: [item.faqQuestions || '', Validators.required],
          contactDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.contactus_faq].push(section);
      });
    }
  }

  /**
 * populateClientResourcesSection() - method to get the exisiting details to display in form
 * @param faqItems - the faq data
 */
  populateClientResourcesSection(faqItems: any[]): void {
    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(item => {
        const section = this.fb.group({
          faqId: [item.faqId || null],
          clientTitle: [item.faqQuestions || '', Validators.required],
          clientDetails: [item.faqAnswers || '', Validators.required]
        });
        this.formGroups[editfaq.client_resource_faq].push(section);
      });
    }
  }

  /**
   * getOverviewSections() - method to return the formGroup
   * @returns - the form group
   */
  getOverviewSections(): FormGroup[] {
    return this.formGroups[editfaq.overview_faq];
  }

  /**
   * getAccountSections() - method to return the formGroup
   * @returns - the form group
   */
  getAccountSections(): FormGroup[] {
    return this.formGroups[editfaq.account_faq];
  }

  /**
   * getProjectsSections() - method to return the formGroup
   * @returns - the form group
   */
  getProjectsSections(): FormGroup[] {
    return this.formGroups[editfaq.projects_faq];
  }

  /**
   * getRequestsSections() - method to return the formGroup
   * @returns - the form group
   */
  getRequestsSections(): FormGroup[] {
    return this.formGroups[editfaq.requests_faq];
  }

  /**
   * getUsersSections() - method to return the formGroup
   * @returns - the form group
   */
  getUsersSections(): FormGroup[] {
    return this.formGroups[editfaq.users_faq];
  }

  /**
   * getContactUsSections() - method to return the formGroup
   * @returns - the form group
   */
  getContactUsSections(): FormGroup[] {
    return this.formGroups[editfaq.contactus_faq];
  }

  /**
   * getClientResourcesSection() - method to return the formGroup
   * @returns - the form group
   */
  getClientResourcesSection(): FormGroup[] {
    return this.formGroups[editfaq.client_resource_faq]
  }

  /**
   * addOverviewSection() - method to add the new form data
   */
  addOverviewSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      title: [null, Validators.required],
      details: [null, Validators.required]
    });
    this.getOverviewSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addAccountSection() - method to add the new form data
   */
  addAccountSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      accountTitle: [null, Validators.required],
      accountDetails: [null, Validators.required]
    });
    this.getAccountSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addProjectsSection() - method to add the new form data
   */
  addProjectsSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      projectTitle: [null, Validators.required],
      projectDetails: [null, Validators.required]
    });
    this.getProjectsSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addRequestsSection() - method to add the new form data
   */
  addRequestsSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      requestTitle: [null, Validators.required],
      requestDetails: [null, Validators.required]
    });
    this.getRequestsSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addUsersSection() - method to add the new form data
   */
  addUsersSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      userName: [null, Validators.required],
      userDetails: [null, Validators.required]
    });
    this.getUsersSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addContactUsSection() - method to add the new form data
   */
  addContactUsSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      contactTitle: [null, Validators.required],
      contactDetails: [null, Validators.required]
    });
    this.getContactUsSections().push(section);
    this.setupFormListeners();
  }

  /**
   * addClientResourceSection() - method to add the new form data
   */
  addClientResourceSection(): void {
    this.isAddingNewFaq = true;
    const section = this.fb.group({
      clientTitle: [null, Validators.required],
      clientDetails: [null, Validators.required]
    });
    this.getClientResourcesSection().push(section);
    this.setupFormListeners();
  }

  /**
   * removeOverviewSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeOverviewSection(index: number): void {
    this.getOverviewSections().splice(index, 1);
  }

  /**
   * removeAccountSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeAccountSection(index: number): void {
    this.getAccountSections().splice(index, 1);
  }

  /**
   * removeProjectsSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeProjectsSection(index: number): void {
    this.getProjectsSections().splice(index, 1);
  }

  /**
   * removeRequestsSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeRequestsSection(index: number): void {
    this.getRequestsSections().splice(index, 1);
  }

  /**
   * removeUsersSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeUsersSection(index: number): void {
    this.getUsersSections().splice(index, 1);
  }

  /**
   * removeContactUsSection() - method to delte the faq
   * @param index - index of the faq to be deleted
   */
  removeContactUsSection(index: number): void {
    this.getContactUsSections().splice(index, 1);
  }

  /**
 * removeClientResourceSection() - method to delte the faq
 * @param index - index of the faq to be deleted
 */
  removeClientResourceSection(index: number): void {
    this.getClientResourcesSection().splice(index, 1);
  }

  /**
   * saveChanges() - method to save the added or edited faq data
   * @param tab - the section in which the faq is present
   */
  saveChanges(tab: string): void {
    this.hasUnsavedChanges = false;
    this.unsavedChangesValue.emit(false);
    this.loaderService.setLoadingState(true);

    const newFaqDetails = [];
    const updatedFaqDetails = [];

    this.formGroups[tab]?.forEach(section => {
      const faqId = section.get('faqId')?.value;
      const faqData = {
        faqQuestions: section.get('title')?.value || section.get('accountTitle')?.value || section.get('projectTitle')?.value || section.get('requestTitle')?.value || section.get('userName')?.value || section.get('contactTitle')?.value || section.get('clientTitle')?.value,
        faqAnswers: section.get('details')?.value || section.get('accountDetails')?.value || section.get('projectDetails')?.value || section.get('requestDetails')?.value || section.get('userDetails')?.value || section.get('contactDetails')?.value || section.get('clientDetails')?.value
      };

      if (!faqId && this.hasChanges(tab)) {
        newFaqDetails.push(faqData);
      } else if (faqId) {
        const originalData = this.originalFaqData[tab].find(item => item.faqId === faqId);

        // Compare current data with original data
        const hasChanged = originalData && (
          originalData.faqQuestions.trim() !== faqData.faqQuestions.trim() ||
          originalData.faqAnswers.trim() !== faqData.faqAnswers.trim()
        );

        if (hasChanged) {
          updatedFaqDetails.push({ faqId, ...faqData });
        }
      }
    });

    const selectedFaqCategory = this.getSelectedFaqCategory(tab);

    if (!this.deletedFaqIds?.length && updatedFaqDetails?.length && newFaqDetails?.length > 0) {
      this.isAddEditFaq = true;
      this.isDeleteFaq = false;
      this.isAddFaq = false;
      this.isEditFaq = false;
      this.isAddDeleteFaq = false;
      this.isEditDeleteFaq = false;
      this.editFaqDetails(updatedFaqDetails);
      this.addFaqDetails(newFaqDetails, selectedFaqCategory);
    }

    if (!updatedFaqDetails?.length && this.deletedFaqIds?.length && newFaqDetails?.length > 0) {
      this.isAddDeleteFaq = true;
      this.isDeleteFaq = false;
      this.isAddFaq = false;
      this.isEditFaq = false;
      this.isEditDeleteFaq = false;
      this.isAddEditFaq = false;
      this.deleteFaqs();
      this.addFaqDetails(newFaqDetails, selectedFaqCategory);
    }

    if (!newFaqDetails?.length && updatedFaqDetails?.length > 0 && this.deletedFaqIds?.length) {
      this.isEditDeleteFaq = true;
      this.isDeleteFaq = false;
      this.isAddFaq = false;
      this.isEditFaq = false;
      this.isAddEditFaq = false;
      this.isAddDeleteFaq = false;
      this.deleteFaqs();
      this.editFaqDetails(updatedFaqDetails);
    }

    if (!this.deletedFaqIds?.length && !newFaqDetails?.length && updatedFaqDetails?.length > 0) {
      this.isEditFaq = true;
      this.isDeleteFaq = false;
      this.isAddFaq = false;
      this.isAddDeleteFaq = false;
      this.isEditDeleteFaq = false;
      this.isAddEditFaq = false;
      this.editFaqDetails(updatedFaqDetails);
    }

    if (!this.deletedFaqIds?.length && !updatedFaqDetails?.length && newFaqDetails?.length > 0) {
      this.isAddFaq = true;
      this.isEditFaq = false;
      this.isDeleteFaq = false;
      this.isAddDeleteFaq = false;
      this.isEditDeleteFaq = false;
      this.isAddEditFaq = false;
      this.addFaqDetails(newFaqDetails, selectedFaqCategory);
    }

    if (!updatedFaqDetails?.length && !newFaqDetails?.length && this.deletedFaqIds?.length > 0) {
      this.isDeleteFaq = true;
      this.isAddFaq = false;
      this.isEditFaq = false;
      this.isAddDeleteFaq = false;
      this.isEditDeleteFaq = false;
      this.isAddEditFaq = false;
      this.deleteFaqs();
    }

    if (updatedFaqDetails?.length > 0 && newFaqDetails?.length > 0 && this.deletedFaqIds?.length > 0) {
      this.isAddDeleteFaq = true;
      this.deleteFaqs();
      this.editFaqDetails(updatedFaqDetails);
      this.addFaqDetails(newFaqDetails, selectedFaqCategory);
    }

    this.loaderService.setLoadingState(false);
  }

  /**
   * deleteFaqs() - method to delete the faq's
   */
  deleteFaqs(): void {
    this.deletedFaqIds.forEach(faqId => {
      this.deleteFaqDetails([faqId]); // Call deleteFaqDetails for each ID
    });
  }

  /**
   * getSelectedFaqCategory() - method to get the category id of the selected tab
   * @param tab - the selected tab (overview, account, your projects etc)
   */
  getSelectedFaqCategory(tab: string): any {
    switch (tab) {
      case this.constants.overview_faq:
        return { faqCategoryId: 1 };
      case this.constants.account_faq:
        return { faqCategoryId: 2 };
      case this.constants.projects_faq:
        return { faqCategoryId: 3 };
      case this.constants.requests_faq:
        return { faqCategoryId: 4 };
      case this.constants.users_faq:
        return { faqCategoryId: 5 };
      case this.constants.contactus_faq:
        return { faqCategoryId: 6 };
      case this.constants.client_resource_faq:
        return { faqCategoryId: 7 };
      default:
        return null;
    }
  }

  /**
   * hasChanges() - method to check if there are any changes done in the faq of a particular tab
   * @param tab - the tab in which changes are made
   * @returns - returns either true or false based on the changes made
   */
  hasChanges(tab: string): boolean {
    const currentSections = this.formGroups[tab];
    const originalSections = this.originalFaqData?.[tab];

    if (originalSections === undefined) {
      return currentSections.some((section, index) => {
        const currentTitle = section.get('title')?.value || section.get('accountTitle')?.value || section.get('projectTitle')?.value || section.get('requestTitle')?.value || section.get('userName')?.value || section.get('contactTitle')?.value || section.get('clientTitle')?.value;
        const currentDetails = section.get('details')?.value || section.get('accountDetails')?.value || section.get('projectDetails')?.value || section.get('requestDetails')?.value || section.get('userDetails')?.value || section.get('contactDetails')?.value || section.get('clientDetails')?.value;

        return currentTitle?.trim() && currentDetails?.trim();
      });
    }

    else {
      return currentSections.some((section, index) => {
        const currentTitle = section.get('title')?.value || section.get('accountTitle')?.value || section.get('projectTitle')?.value || section.get('requestTitle')?.value || section.get('userName')?.value || section.get('contactTitle')?.value || section.get('clientTitle')?.value;
        const currentDetails = section.get('details')?.value || section.get('accountDetails')?.value || section.get('projectDetails')?.value || section.get('requestDetails')?.value || section.get('userDetails')?.value || section.get('contactDetails')?.value || section.get('clientDetails')?.value;

        const originalTitle = originalSections[index]?.faqQuestions;
        const originalDetails = originalSections[index]?.faqAnswers;

        return currentTitle?.trim() !== originalTitle?.trim() || currentDetails?.trim() !== originalDetails?.trim();
      });
    }
  }

  /**
   * addFaqDetails() - method to subscribe to the post api call
   * @param newFaqDetails - new faq details to be added
   * @param selectedFaqCategory - the faq category where the faq is to be added
   */
  addFaqDetails(newFaqDetails: any[], selectedFaqCategory: any): void {
    const addPayload = {
      faqCategoryId: selectedFaqCategory?.faqCategoryId,
      loginUserId: JSON.parse(localStorage.getItem('user-profile')).userProfileId,
      faq: newFaqDetails
    };

    this.FaqServiceService.addFaqData(addPayload).subscribe({
      next: (response) => {
        if (response) {
          if (!this.isUnsavedChangesOpened) {
            if (this.isAddEditFaq || this.isAddDeleteFaq && !this.isAddFaq) {
              this.isAddingNewFaq = false;
              this.modeChange.emit('View');
              this.toastMessage.emit({ type: 'success', message: this.successMessages.editSuccess });
            }
            else if (this.isAddFaq) {
              this.isAddingNewFaq = true;
              this.modeChange.emit('View');
              this.toastMessage.emit({ type: 'success', message: this.successMessages.addSuccess });
            }
          }
          else if (this.isUnsavedChangesOpened && !this.isAddDeleteFaq) {
            this.toastMessage.emit({ type: 'success', message: this.successMessages.addSuccess });
          }
          this.loaderService.setLoadingState(false);
          this.resetChanges(this.selectedTab);
        }
      },
      error: (error) => {
        console.error(`Error saving form data FAQ data:`, error);
        this.errorMessage = error;
        this.loaderService.setLoadingState(false);
        this.toastMessage.emit({ type: 'danger', message: this.errorMessage });
      }
    });
  }

  /**
   * editFaqDetails() - method to subscribe to edit faq api call
   * @param updatedFaqDetails - the updated faq details
   */
  editFaqDetails(updatedFaqDetails: any[]): void {
    const updatePayload = {
      faq: updatedFaqDetails,
      loginUserId: JSON.parse(localStorage.getItem('user-profile')).userProfileId
    };

    this.FaqServiceService.updateFaqData(updatePayload).subscribe({
      next: (response) => {
        if (response) {
          if (!this.isUnsavedChangesOpened) {
            if (this.isEditDeleteFaq || this.isAddEditFaq || this.isEditFaq) {
              this.modeChange.emit('View');
              this.toastMessage.emit({ type: 'success', message: this.successMessages.editSuccess });
            }
          }
          else if (this.isUnsavedChangesOpened) {
            this.toastMessage.emit({ type: 'success', message: this.successMessages.editSuccess });
          }
          this.loaderService.setLoadingState(false);
          this.resetChanges(this.selectedTab);
        }
      },
      error: (error) => {
        console.error(`Error editing FAQ:`, error);
        this.errorMessage = error;
        this.loaderService.setLoadingState(false);
        this.toastMessage.emit({ type: 'danger', message: this.errorMessage });
      }
    });
  }

  /**
   * discardChanges() - method to discard the changes made in faq
   * @param tab - the section in which the faq is present
   */
  discardChanges(tab: string): void {
    this.selectedTab = tab;
    this.OpenWarningModal();
  }

  /**
   * resetChanges() - Reset the form data to its initial state
   * @param tab - the section in which the faq is present
  */
  resetChanges(tab: string): void {
    this.selectedTab = tab;
    this.setupFormListeners();
    this.getFaqData();
    this.initializeForms();
    this.hasUnsavedChanges = false;
    this.unsavedChangesValue.emit(false);
    this.deletedFaqIds = [];
    this.isUnsavedChangesOpened = false;
  }

  /**
   * OpenWarningModal() - Method to close the modal on X 
  */
  OpenWarningModal(): void {
    this.modalService.open(this.WarningMsgModal, {
      windowClass: 'common-modal-center',
      centered: true,
      backdrop: 'static'
    });
  }

  /**
   * handleNavigation() - method to navigate to other pages
   */
  handleNavigation(): void {
    this.setupFormListeners();
  }
  /**
   * selectTab() - method to select the tab/section
   * @param tab - the section for ex: overview/account/your projects etc;
   */
  selectTab(tab: string): void {
    const trimmedTab = tab.replace('-tab', '');
    this.selectedTab = trimmedTab;
    if (this.selectedTab) {
      this.prevtabArr.push(this.selectedTab);
      if (this.prevtabArr?.length <= 1) {
        this.previousTab = this.prevtabArr[this.prevtabArr?.length - 1];
      }
      else {
        this.previousTab = this.prevtabArr[this.prevtabArr?.length - 2];
      }
    }
    this.setupFormListeners();
    if (this.hasChanges(this.previousTab) || this.deletedFaqIds?.length) {
      this.openUnsavedChangesModal(this.previousTab);
    } else {
      this.selectedTab = tab;
    }
  }

  /**
   * openDeleteConfirmationModal() - method to open the confirmation modal for faq delete
   * @param content - the modal template
   * @param tab - the tab in which faq to be deleted is present
   * @param index - index of the faq to be deleted
   */
  openDeleteConfirmationModal(content: TemplateRef<any>, tab: string, index: number): void {
    // Store the tab and index for deletion confirmation
    this.tabToDelete = tab;
    this.indexToDelete = index;

    // Open the confirmation modal
    this.modalService.open(content, { windowClass: 'common-modal-center', centered: true, backdrop: 'static' });
  }

  /**
   * confirmDelete() - method to subscribe to delete faq api call
   */
  confirmDelete(): void {
    if (this.tabToDelete && this.indexToDelete !== null) {
      const faqId = this.formGroups[this.tabToDelete][this.indexToDelete].get('faqId')?.value;
      if (faqId && !this.deletedFaqIds.includes(faqId)) {
        this.deletedFaqIds.push(faqId); // Push faqId here after confirmation
        this.hasUnsavedChanges = true;
        this.unsavedChangesValue.emit(true);
      }
      this.removeSection(this.tabToDelete, this.indexToDelete); // Remove the section
    }
    this.modalService.dismissAll();

    this.tabToDelete = null;
    this.indexToDelete = null;
  }

  /**
   * deleteFaqDetails() - method to subscribe to the delete api call
   * @param faqIds - Id's of the faq's to be deleted 
   */
  // deleteFaqDetails(faqIds: number[]): void {
  //   this.loaderService.setLoadingState(true);

  //   this.FaqServiceService.deleteFaqData(faqIds).subscribe({
  //     next: (response) => {
  //       if (response) {
  //         this.deletedFaqIds.forEach(id => {
  //           Object.keys(this.formGroups).forEach(tab => {
  //             this.formGroups[tab] = _.filter(this.formGroups[tab], section => section.get('faqId')?.value !== id);
  //           });
  //         });

  //         // Reset the deletedFaqIds array after deletion
  //         this.deletedFaqIds = [];

  //         if (!this.isUnsavedChangesOpened) {
  //           if (this.isAddDeleteFaq || this.isEditDeleteFaq && !this.isDeleteFaq) {
  //             this.modeChange.emit('View');
  //             this.toastMessage.emit({ type: 'success', message: this.successMessages.editSuccess });
  //           }
  //           if (this.isDeleteFaq) {
  //             this.modeChange.emit('View');
  //             this.toastMessage.emit({ type: 'success', message: this.successMessages.deleteSuccess });
  //           }
  //         }
  //         else if (this.isUnsavedChangesOpened) {
  //           this.toastMessage.emit({ type: 'success', message: this.successMessages.deleteSuccess });
  //         }
  //       }
  //       this.loaderService.setLoadingState(false);
  //       this.resetChanges(this.selectedTab);
  //     },
  //     error: (error) => {
  //       console.error('Error deleting FAQ:', error);
  //       this.errorMessage = error;
  //       this.loaderService.setLoadingState(false);
  //       this.toastMessage.emit({ type: 'danger', message: this.errorMessage });
  //     }
  //   });
  // }
deleteFaqDetails(faqIds: number[]): void {
  this.loaderService.setLoadingState(true);
 
  this.FaqServiceService.deleteFaqData(faqIds).subscribe({
    next: (response) => this.handleDeleteSuccess(response),
    error: (error) => this.handleDeleteError(error)
  });
}
 
// ---------------------- Helper Methods ----------------------
 
private handleDeleteSuccess(response: any): void {
  if (response) {
    this.removeDeletedFaqs();
    this.resetDeletedIds();
    this.handleSuccessMessage();
  }
 
  this.loaderService.setLoadingState(false);
  this.resetChanges(this.selectedTab);
}
 
private handleDeleteError(error: any): void {
  console.error('Error deleting FAQ:', error);
  this.errorMessage = error;
 
  this.loaderService.setLoadingState(false);
  this.toastMessage.emit({ type: 'danger', message: this.errorMessage });
}
 
// ---------------------- Small Logic Blocks ----------------------
 
private removeDeletedFaqs(): void {
  this.deletedFaqIds.forEach(id => this.removeFaqFromFormGroups(id));
}
 
private removeFaqFromFormGroups(id: number): void {
  Object.keys(this.formGroups).forEach(tab => {
    this.formGroups[tab] = _.filter(
      this.formGroups[tab],
      section => section.get('faqId')?.value !== id
    );
  });
}
 
private resetDeletedIds(): void {
  this.deletedFaqIds = [];
}
 
private handleSuccessMessage(): void {
  if (!this.isUnsavedChangesOpened) {
    if ((this.isAddDeleteFaq || this.isEditDeleteFaq) && !this.isDeleteFaq) {
      this.emitSuccess(this.successMessages.editSuccess);
    } else if (this.isDeleteFaq) {
      this.emitSuccess(this.successMessages.deleteSuccess);
    }
  } else {
    this.emitSuccess(this.successMessages.deleteSuccess);
  }
}
 
private emitSuccess(message: string): void {
  this.modeChange.emit('View');
  this.toastMessage.emit({ type: 'success', message });
}

  /**
   * removeSection() - method to remove the deleted faq
   * @param tab - the section in which deleted faq is present earlier
   * @param index - index of the deleted faq
   */
  removeSection(tab: string, index: number): void {
    switch (tab) {
      case editfaq.overview_faq:
        this.removeOverviewSection(index);
        break;
      case editfaq.account_faq:
        this.removeAccountSection(index);
        break;
      case editfaq.projects_faq:
        this.removeProjectsSection(index);
        break;
      case editfaq.requests_faq:
        this.removeRequestsSection(index);
        break;
      case editfaq.users_faq:
        this.removeUsersSection(index);
        break;
      case editfaq.contactus_faq:
        this.removeContactUsSection(index);
        break;
      case editfaq.client_resource_faq:
        this.removeClientResourceSection(index);
        break;
      default:
        break;
    }
  }

  /**
   * openUnsavedChangesModal() - method to open the unsaved changes modal
   * @param tab - current section
   */
  openUnsavedChangesModal(tab: string): void {
    this.isUnsavedChangesOpened = true;
    const modalRef = this.modalService.open(this.unsavedChangesModalContent,
      {
        windowClass: 'common-modal-center',
        centered: true,
        backdrop: 'static'
      });
    modalRef.result.then(
      (result) => {
        this.selectedTab = `${this.prevtabArr[this.prevtabArr?.length - 1]}-tab`;
        if (result) {
          this.saveChanges(tab);
          this.hasUnsavedChanges = false;
        } else {
          this.resetChanges(this.selectedTab);
        }
      },
      (reason) => {
        console.warn('Modal dismissed:', reason);
      }
    );
  }

  /**
   * openSubmitModal() - method to open the submit modal when user clicks submit button
   * @param tab 
   */
  openSubmitModal(tab: string): void {
    const modalRef = this.modalService.open(this.submitModal, {
      windowClass: 'common-modal-center',
      centered: true,
      backdrop: 'static'
    });
    modalRef.result.then((result) => {
      if (result) {
        // User clicked "Yes", call the saveChanges method
        this.saveChanges(tab);
      }
      // If "No" is clicked, do nothing and the modal will close automatically
    }, (error) => {
      // Handle modal dismissal if needed
    });
  }

  /**
   * isOverviewFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isOverviewFormInvalid(): boolean {
    const sections = this.getOverviewSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isAccountFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isAccountFormInvalid(): boolean {
    const sections = this.getAccountSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isProjectsFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isProjectsFormInvalid(): boolean {
    const sections = this.getProjectsSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isRequestsFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isRequestsFormInvalid(): boolean {
    const sections = this.getRequestsSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isUsersFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isUsersFormInvalid(): boolean {
    const sections = this.getUsersSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isContactUsFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isContactUsFormInvalid(): boolean {
    const sections = this.getContactUsSections();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }

  /**
   * isClientResourceFormInvalid() - method to check if the respective tab form is invalid
   * @returns - true if the form is invalid
   */
  isClientResourceFormInvalid(): boolean {
    const sections = this.getClientResourcesSection();
    const allValid = _.every(sections, 'valid');
    const allPristine = _.every(sections, 'pristine');
    this.isInvalid = !allValid || allPristine;
    return this.isInvalid;
  }
}